import script from "./BaseTableHeaderItem.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseTableHeaderItem.vue?vue&type=script&setup=true&lang=js"

import "./BaseTableHeaderItem.vue?vue&type=style&index=0&id=1fe7c9a0&lang=scss&scoped=true"
script.__scopeId = "data-v-1fe7c9a0"

export default script